import React from "react";
export function AboutSection() {
  return <section id="about" className="border-t border-cream-line py-20 lg:py-28" data-id="element-10" data-mp="3nndh90gac54q">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 sm:px-8 lg:grid-cols-2 lg:gap-20" data-id="element-11" data-mp="2ldhuawjye5su">
        <h2 className="text-3xl font-semibold leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-12" data-mp="2gbsiheowpo3p">
          Kenapa “Lima Detik”? Karena hanya itu waktu yang dibutuhkan untuk merasa lebih baik.
        </h2>
        <div className="space-y-5 text-base leading-relaxed text-ink-muted" data-id="element-13" data-mp="27d70bknckb3g">
          <p data-id="element-14" data-mp="22lf7t4kmrvao">
            Kami berawal pada 2019 sebagai kios taman kecil di SCBD dengan satu mesin espresso dan
            satu ide sederhana: seruputan pertama kopi yang enak harus memberimu lima detik
            ketenangan, seramai apa pun kotanya.
          </p>
          <p data-id="element-15" data-mp="1noeqzw3z9kqz">
            Kini kami menyangrai Arabika medium dari Gayo, Kintamani, dan Flores, merawat tanaman
            yang mengisi setiap ruang kami, dan mengadakan aktivitas mingguan yang mengubah
            pelanggan setia menjadi sebuah komunitas.
          </p>
        </div>
      </div>
    </section>;
}